import { Dispatch, SetStateAction, memo, useCallback, useEffect } from 'react';
import { Element } from '@zmedia/bm-soccer-ui/components';
import SearchItem from './SearchItem';
import { SearchTabs } from './SearchTab';
import { Scrollbars } from '@zmedia/bm-soccer-ui/components/scrollbar';
import { ISuggest, TTabType } from './constant';
import Empty from '@zmedia/bm-soccer-ui/modules/shared/components/Empty';
import styles from './search.module.scss';

interface IProps {
    keyword: string;
    suggest: ISuggest;
    resetSuggest: () => void;
    setActiveTab: Dispatch<SetStateAction<TTabType>>;
    activeTab: TTabType;
}

const SearchDropdown = ({
    suggest,
    resetSuggest,
    setActiveTab,
    activeTab,
}: IProps) => {
    const tabList = Object.keys(suggest) as any;
    const _suggest = suggest[activeTab] || [];

    const renderItems = useCallback(() => {
        return _suggest.map((item: any, index: number) => (
            <SearchItem
                index={index}
                key={item.id}
                onClick={resetSuggest}
                item={item}
                type={activeTab}
            />
        ));
    }, [_suggest]);

    useEffect(() => {
        if (!activeTab) {
            setActiveTab(tabList[0]);
        }
    }, [activeTab]);

    if (!_suggest.length)
        return (
            <Element className={styles['soccer-search-dropdown']}>
                <Empty content="Chưa có thông tin tìm kiếm" />
            </Element>
        );

    return (
        <Element className={styles['soccer-search-dropdown']}>
            <SearchTabs
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                tabList={tabList}
            />
            <Element renderAs="ul" className={styles['search-list']}>
                <Scrollbars
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                    disableScrollParent={true}
                    id={'search-scroll'}
                >
                    {renderItems()}
                </Scrollbars>
            </Element>
        </Element>
    );
};

export default memo(SearchDropdown);
